import {Col, Container, Row} from "react-bootstrap";
import mainImg from "../images/main.JPG";
import classes from "../styles/pages/homePage.module.scss";
import elements from "../styles/settings/elements.module.scss";
import Reviews from "../components/reviews/Reviews";
import Products from "../components/home/Products";
import Services from "../components/home/Services";

function HomePage(){
    return(
        <Container fluid>
            <Row className={`${classes.meBlock} ${elements.blockDivider}`}>
                <Col xl={8} lg={6} md={12} sm={12} xs={12}>
                    <h1 className={elements.meTitle}>About Me</h1>
                    <p className={classes.meDescription}>I am Maria, a seasoned cosmetologist with 7 years of experience specializing in acne treatment and age-related skin care. My passion for the field and dedication to using high-quality products drive my commitment to delivering exceptional results. With an in-depth understanding of skin health and its complexities, I provide personalized treatments tailored to each client's unique needs. My advanced techniques and individualized approach have consistently led to successful outcomes and high client satisfaction. I am committed to continuous professional growth, regularly updating my knowledge and skills to offer the best care and recommendations. My goal is to help clients achieve healthy, radiant skin through expert guidance and effective treatments.</p>
                </Col>
                <Col xl={4} lg={6} md={12} sm={12} xs={12}>
                    <img src={mainImg} className={classes.meImg}/>
                </Col>
            </Row>

            <h1 className={elements.blockTitle}>Bestsellers</h1>
            <Products count={4}/>

            <Services count={3}/>

            {/*<Row>*/}
            {/*    <Col>*/}
            {/*        <Reviews/>*/}
            {/*    </Col>*/}
            {/*</Row>*/}
        </Container>
    );
}

export default HomePage;